import application from 'application/application';

import template from './add-processes-quick-register-oab.template.html';

import controller from './add-processes-quick-register-oab.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.addProcessesOab', {
			url: '/cadastrar-processos-oab?id',
			views: {
				'default@root.default': {
					templateUrl: template,
					controller
				}
			},
			data: {
				documentTitle: 'Cadastrar processos OAB'
			}
		});
	}
]);
